import { Effect } from 'effect';
import type { TFunction } from 'i18next';
import type { ToolDef } from '@/features/tools/data';

function catalogKey(slug: string): string {
  return slug.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

function localizeToolInternal(tool: ToolDef, t: TFunction): ToolDef {
  const base = `tools.catalog.${catalogKey(tool.slug)}`;
  return {
    ...tool,
    name: t(`${base}.name`, { defaultValue: tool.name }),
    description: t(`${base}.description`, { defaultValue: tool.description }),
    metaTitle: t(`${base}.metaTitle`, { defaultValue: tool.metaTitle }),
    metaDescription: t(`${base}.metaDescription`, { defaultValue: tool.metaDescription }),
    h1: t(`${base}.h1`, { defaultValue: tool.h1 }),
    subhead: tool.subhead ? t(`${base}.subhead`, { defaultValue: tool.subhead }) : undefined,
    badge: tool.badge ? t(`${base}.badge`, { defaultValue: tool.badge }) : undefined,
    bullets: tool.bullets.map((bullet, index) =>
      t(`${base}.bullets.${index}`, { defaultValue: bullet }),
    ),
    steps: tool.steps?.map((step, index) => t(`${base}.steps.${index}`, { defaultValue: step })),
    faq: tool.faq?.map((item, index) => ({
      q: t(`${base}.faq.${index}.q`, { defaultValue: item.q }),
      a: t(`${base}.faq.${index}.a`, { defaultValue: item.a }),
    })),
  };
}

export const localizeToolEffect = Effect.fn('web.i18n.localizeTool')(function* (
  tool: ToolDef,
  t: TFunction,
) {
  return localizeToolInternal(tool, t);
});

export function localizeTool(tool: ToolDef, t: TFunction): ToolDef {
  return Effect.runSync(localizeToolEffect(tool, t));
}
